// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import FormattedDateOrDashes from '../../../../components/FormattedDateOrDashes';
import messages from '../../messages';

type Props = {
  offerDate: ?string,
  offerExpirationDate: ?string,
};

const OfferHeader = ({ offerDate, offerExpirationDate }: Props) => (
  <Box
    sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}
    data-test="previous-offer-header"
  >
    <Stack direction="row" spacing={4}>
      <Typography variant="bodyMedium">
        <i className="icon et-calendar" style={{ marginRight: 8 }} />
        <strong>
          <FormattedMessage {...messages.offerDate} />:
        </strong>{' '}
        <FormattedDateOrDashes value={offerDate} format="MM/DD/YYYY" />
      </Typography>
      <Typography variant="bodyMedium">
        <i className="icon et-calendar" style={{ marginRight: 8 }} />
        <strong>
          <FormattedMessage {...messages.offerExpires} />:
        </strong>{' '}
        <FormattedDateOrDashes
          value={offerExpirationDate}
          format="MM/DD/YYYY"
        />
      </Typography>
    </Stack>
  </Box>
);

export default OfferHeader;
